module.exports = __webpack_public_path__ + "img/icon1.29c14dd8.png";